import { getrandom7DayDDMMYYYY } from "@/components/widgets/analytics/ClientSummaryReport/ClientSummaryReportHelpers";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import analyticDataStore, {
  IBaseAnalyticsCombined,
} from "./analyticsDataStore";

function generateSecurityType(): "IRS" | "ZCS" | "OIS" | "SWO" {
  const secOptions = ["IRS", "ZCS", "OIS", "SWO"];
  const chance = Math.floor(Math.random() * secOptions.length);

  const val = secOptions[chance] as "IRS" | "ZCS" | "OIS" | "SWO";
  return val;
}

function generateSecurityName(type: "IRS" | "ZCS" | "OIS" | "SWO") {
  if (type == "IRS") {
    return "IRS (single) 9 June 15 to 9 Sep 15";
  } else if (type == "ZCS") {
    return "10yr ZCS";
  } else if (type == "OIS") {
    return "Apr - May OIS";
  } else if (type == "SWO") {
    return "AUD SWO 3M2Y ATM Payer vs AUD SWO 3M2Y ATM Receiver";
  } else return "2y1y";
}

function generateTraderName() {
  const nameOptions = ["Jane A", "Nick P", "Aiden N", "Sally W", "Michelle G"];
  const chance = Math.floor(Math.random() * nameOptions.length);
  return nameOptions[chance];
}

function generateDirection(type: "IRS" | "ZCS" | "OIS" | "SWO") {
  const directionOpitons = ["Pay", "Receive"];
  const directionOptionsSWO = ["Buy", "Sell"];
  const chance = Math.floor(Math.random() * 2);
  if (type == "SWO") {
    return directionOptionsSWO[chance];
  }
  return directionOpitons[chance];
}

function generateCurrency() {
  const currency = ["AUD", "NZD", "GBP", "USD"];
  const chance = Math.floor(Math.random() * currency.length);
  return currency[chance];
}

function generateNumberBelowTen() {
  const chance = Math.floor(Math.random() * 10);
  const decimal = Math.floor(Math.random() * 99);

  const randomNumber = `${chance}.${decimal}`;
  return Number(randomNumber);
}

function generateDV01() {
  const largeN = Math.floor(Math.random() * 1000);
  const smallN = Math.floor(Math.random() * 999);

  const randomNumber = `${largeN}${smallN}`;
  return Number(randomNumber);
}

function generateSpreadToMid() {
  const largeN = Math.floor(Math.random() * 1000);

  const randomNumber = `0.${largeN}`;
  return Number(randomNumber);
}

function generateBidOffer() {
  return generateSpreadToMid();
}

function generateCostVsMid() {
  const largeN = Math.floor(Math.random() * 1000);
  const smallN = Math.floor(Math.random() * 999);

  const randomNumber = `${largeN}.${smallN}`;
  return Number(randomNumber);
}

function ranCountry() {
  const randomNum = Math.floor(Math.random() * 4);
  const country = ["Australia", "Canada", "Germany", "United Kingdom"];
  return country[randomNum];
}

function ranStatus() {
  const randomNum = Math.floor(Math.random() * 2);
  const statusToPick = [
    ExecutionStrategyStatus.Affirmed,
    ExecutionStrategyStatus.Sent,
  ];
  return statusToPick[randomNum];
}

// NO connection to endpoints yet.
export function addNewAnalticToStore() {
  function generateRandomTrade(): IBaseAnalyticsCombined {
    function randomTradeID() {
      const randomNum = Math.floor(Math.random() * 10000);
      return randomNum;
    }
    const { year, month, day } = getrandom7DayDDMMYYYY();
    const currentStatus = ranStatus();

    const tempSec = generateSecurityType();
    const objTest: IBaseAnalyticsCombined = {
      id: randomTradeID(), // indexed id, unique for each row not related to the trade but will be used to provide ag chart with a unique field.
      tradeID: "LDC-" + randomTradeID(),
      spread: generateNumberBelowTen(), //NOT on EXCEL data
      lastAction: currentStatus, // EXCEL data does NOT have any usefull last actions.
      dateTimeSent: `${year}-${month}-${day}T01:26:30.2630`, // EXCEL data has this as time rather than a date.
      dateTimeQuoted: `${year}-${month}-${day}T01:27:30.2630`,
      dateTimeExecuted:
        currentStatus == ExecutionStrategyStatus.Sent
          ? `${year}-${month}-${day}T01:29:30.2630`
          : "", // Are both these dates needed??
      dateTimeAffirmed:
        currentStatus == ExecutionStrategyStatus.Sent
          ? `${year}-${month}-${day}T01:29:50.2630`
          : "", // Are both these dates needed??
      currency: "AUD",
      issueCountry: ranCountry(),
      notional: 100000,
      instrumentType: "SWP",
      structureType: "Pack",
      securityType: tempSec, // HOW is this different to the "SWP" on instrumentType??
      strategyType: "Outright",
      securityName: generateSecurityName(tempSec),
      currencyLeg1: generateCurrency(),
      DV01: generateDV01(),
      OPCustomer: "LDC",
      RPCustomer: "JBD",
      DV01Buckets: "0 - 5k",
      // MaturityDate?: string | Date, - // Seems to be for axes.
      // Sector: string, - // Sector is coming from the client summary report - It does not seem to be getting used anywhere.
      // Ticker: string, - // Client summary - It does not seem to be getting used anywhere. (seems to be a near duplciate from the issuer / issuer could be used instead for most use cases.)
      OPTraderName: generateTraderName(), // Not sure what this is? The OP who made it or do we need 2 names here?
      RPTraderName: generateTraderName(),
      //   trader: string, // Is this not trader name? See above.
      direction: generateDirection(tempSec),
      mid: generateNumberBelowTen(),
      cover: generateNumberBelowTen(),
      spreadToMid: generateSpreadToMid(),
      bidOffer: generateBidOffer(),
      tradeCostVsMid: generateCostVsMid(),
      timeToQuote: generateSpreadToMid(),
      priceType: "bps",
      rate: "",
      issuer: "CIT",
      spreadAsk: 0,
      spreadBid: 0,
      blockAsk: 0,
      blockBid: 0,
      maturityDate: "",
      sector: "",
      ticker: "",
      traderLocation: "",
      block: 0,
      spreadBPS: 50,
      blockBPS: 50,
    };

    return objTest;
  }
  const newAnalyticsItem: IBaseAnalyticsCombined = generateRandomTrade();

  const currentData = analyticDataStore.getState().analyticData;
  const newData = [...currentData, newAnalyticsItem];
  analyticDataStore.getState().updateAnalyticData(newData);
}
